// What a "careers page" means when tracking a company: a mini mock of a job-listings page,
// then which links work and which don't. Shown inside the Track a company walkthrough.
import React from "react";
import styled from "styled-components";
import { FiCheck, FiX } from "react-icons/fi";

const ROLES = [
  ["Senior Associate, Banking & Finance", "Hong Kong"],
  ["Trainee Solicitor 2027", "London"],
  ["Knowledge Lawyer, Disputes", "Singapore"],
];

export default function CareersPageExample() {
  return (
    <Wrap>
      <p className="lead">
        The careers page is the page on the firm's website that <b>lists all its open jobs</b>, usually linked as
        Careers, Jobs or Join us. Open it in another tab and copy the address from the top of the browser.
      </p>
      <Browser aria-hidden>
        <div className="bar">
          <span className="dots">
            <i />
            <i />
            <i />
          </span>
          <span className="url">careers.bakermckenzie.com/…/SearchJobs</span>
        </div>
        <div className="page">
          <div className="h">Open positions</div>
          {ROLES.map(([t, l]) => (
            <div className="row" key={t}>
              <div>
                <div className="t">{t}</div>
                <div className="l">{l}</div>
              </div>
              <span className="apply">Apply</span>
            </div>
          ))}
        </div>
      </Browser>
      <div className="lists">
        <div>
          <div className="lh ok">
            <FiCheck size={12} /> Use
          </div>
          <ul>
            <li>The page listing all openings</li>
            <li>Job sites like Workday, Greenhouse or Workable</li>
          </ul>
        </div>
        <div>
          <div className="lh no">
            <FiX size={12} /> Not
          </div>
          <ul>
            <li>The company homepage</li>
            <li>A single job ad, a PDF or a LinkedIn page</li>
          </ul>
        </div>
      </div>
    </Wrap>
  );
}

const Wrap = styled.div`
  .lead { margin: 0 0 10px; }
  .lead b { color: var(--ink); font-weight: 600; }
  .lists { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-top: 10px; font-size: 12px; }
  .lh { display: inline-flex; align-items: center; gap: 4px; font-weight: 600; font-size: 11px; text-transform: uppercase; letter-spacing: .05em; }
  .lh.ok { color: var(--success, #1a7f4b); }
  .lh.no { color: var(--danger, #c0392b); }
  ul { margin: 4px 0 0; padding-left: 16px; color: var(--ink-muted); }
  li + li { margin-top: 2px; }
`;

const Browser = styled.div`
  border: 1px solid var(--line);
  border-radius: 10px;
  overflow: hidden;
  background: var(--bg);
  font-size: 11.5px;
  .bar { display: flex; align-items: center; gap: 8px; padding: 6px 8px; background: var(--bg-2, var(--line)); border-bottom: 1px solid var(--line); }
  .dots { display: inline-flex; gap: 4px; }
  .dots i { width: 7px; height: 7px; border-radius: 99px; background: var(--line-strong, var(--ink-faint, #aaa)); display: block; }
  .url { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; background: var(--surface); border-radius: 5px; padding: 2px 7px; color: var(--ink-muted); font-family: "Geist Mono", ui-monospace, monospace; font-size: 10.5px; }
  .page { padding: 10px 12px 6px; }
  .h { font-family: "Instrument Serif", Georgia, serif; font-size: 16px; color: var(--ink); margin-bottom: 6px; }
  .row { display: flex; align-items: center; justify-content: space-between; gap: 8px; padding: 6px 0; border-top: 1px solid var(--line); }
  .t { color: var(--ink); font-weight: 600; }
  .l { color: var(--ink-muted); font-size: 10.5px; }
  .apply { flex-shrink: 0; font-size: 10.5px; font-weight: 600; color: var(--accent); border: 1px solid var(--accent); border-radius: 6px; padding: 1px 7px; }
`;
